// Keep legacy Graphite tenants separate from the Zentrolink company footer.
// Zentrolink is also accepted for the independent theme introduced by epic 189.
export function hasZentrolinkFooter(individual, brand = globalThis.window?.__PROCESSING_BRAND__) {
  return ['Graphite', 'Zentrolink'].includes(individual) && brand?.name === 'Zentrolink';
}
